export default __webpack_public_path__ + "static/media/union.50994a5d.svg";